module.exports = __webpack_public_path__ + "img/indicadores.33a51ed3.jpg";